import { useAtomValue } from 'jotai';
import { filtersToPersistAtom } from '@/atoms/filters/persistedFilters';
import { teamEventsForMetricCountAtom } from '@/atoms/queries/team/teamEventData';
import { teamIdAtom } from '@/atoms/team/team';
import { EntityMetricPreviewPanel } from '@/components/preview/EntityMetricPreviewPanel';
import { TeamPreviewEvents } from '@/components/team/radar/preview/TeamPreviewEvents';
import { teamPitchVisComponents } from '@/consts/visualisationComponents';

const TeamEventMap = teamPitchVisComponents.eventMap;

export const TeamPrimaryPreviewPanel = () => {
  const teamId = useAtomValue(teamIdAtom);
  const filters = useAtomValue(filtersToPersistAtom);

  return (
    <EntityMetricPreviewPanel
      pathTo={`../../../team/${teamId}/vis`}
      eventsForMetricCountAtom={teamEventsForMetricCountAtom}
      filtersToHydrate={filters}
      eventMap={<TeamEventMap isPreview />}
    >
      <TeamPreviewEvents />
    </EntityMetricPreviewPanel>
  );
};
